import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

type CCClipboardProps = {
  children: React.ReactNode;
  copy: string;
  id?: string;
  className?: string;
  onCopy?: () => void;
};

function CCClipboard({
  id = null,
  children,
  onCopy = () => {},
  copy,
  className = null,
}: CCClipboardProps) {
  return (
    <CopyToClipboard text={copy} onCopy={onCopy}>
      <button
        data-testid={id ?? 'action-copy-link'}
        type="button"
        className={className || 'link-copy-box-button'}
      >
        {children}
      </button>
    </CopyToClipboard>
  );
}

export default CCClipboard;
